'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _Checkbox = require('components/Checkbox/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _utils = require('helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./SongsListRow.scss');

var SongsListRow = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(SongsListRow, _PureComponent);

  function SongsListRow() {
    (0, _classCallCheck3.default)(this, SongsListRow);
    return (0, _possibleConstructorReturn3.default)(this, (SongsListRow.__proto__ || (0, _getPrototypeOf2.default)(SongsListRow)).apply(this, arguments));
  }

  (0, _createClass3.default)(SongsListRow, [{
    key: 'onClick',
    value: function onClick() {
      var _props = this.props,
          onClick = _props.onClick,
          song = _props.song;

      onClick(song);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          song = _props2.song,
          index = _props2.index,
          checked = _props2.checked;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.row), onClick: this.onClick },
        _react2.default.createElement(
          'div',
          { className: styles.index },
          index + 1
        ),
        _react2.default.createElement(
          'div',
          { className: styles.title },
          song.trackName
        ),
        _react2.default.createElement(
          'div',
          { className: styles.artist },
          song.albumArtist
        ),
        _react2.default.createElement(
          'div',
          null,
          song.durationTime
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_Checkbox2.default, {
            className: 'padding-5 inline',
            checked: checked,
            onClick: _utils.stopEvent,
            small: true
          })
        )
      );
    }
  }]);
  return SongsListRow;
}(_react.PureComponent), _class2.propTypes = {
  checked: _propTypes2.default.bool,
  index: _propTypes2.default.number,
  onClick: _propTypes2.default.func,
  song: _propTypes2.default.object
}, _class2.defaultProps = {
  index: 0,
  song: {},
  onClick: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype)), _class);
exports.default = SongsListRow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SongsList/SongsListRow.js
// module id = 2099
// module chunks = 1